import React from 'react';
import { Typography, Box, FormHelperText, IconButton } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';

// Label above the input (the design has no floating labels). `hint` is the muted help text below.
export const Field = ({ classes, label, required, hint, error, children }) => (
  <div className={classes.field}>
    {label && (
      <label className={classes.fieldLabel}>
        {label}
        {required && <span className={classes.required}> *</span>}
      </label>
    )}
    {children}
    {error
      ? <FormHelperText error>{error}</FormHelperText>
      : hint && <div className={classes.hint}>{hint}</div>}
  </div>
);

// Heart next to an address input: opens the client's favorite addresses for that field.
export const FavoriteAddressButton = ({ label, onClick }) => (
  <IconButton aria-label={label} title={label} color="primary" size="small" onClick={onClick} style={{ marginLeft: 8 }}>
    <FavoriteBorderOutlinedIcon style={{ fontSize: 28 }} />
  </IconButton>
);

// Icon badge + title + subtitle that heads each column of a card.
export const ColumnTitle = ({ classes, icon, color, background, title, subtitle }) => (
  <Box display="flex" alignItems="center" mb={3}>
    <div className={classes.iconBadge} style={{ background, color }}>{icon}</div>
    <div>
      <Typography variant="subtitle1" style={{ fontWeight: 700, lineHeight: 1.2 }}>{title}</Typography>
      <Typography variant="caption" color="textSecondary">{subtitle}</Typography>
    </div>
  </Box>
);

const Dot = ({ number, state }) => {
  const active = state === 'active';
  const done = state === 'done';
  return (
    <div
      style={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        fontWeight: 700,
        background: active ? '#6A2CC0' : '#fff',
        color: active ? '#fff' : '#555',
        border: active ? 'none' : '1px solid #D0D0D8'
      }}
    >
      {done ? <CheckIcon style={{ fontSize: 16 }} /> : number}
    </div>
  );
};

export const Stepper = ({ steps, current }) => (
  <Box display="flex" alignItems="center" mb={2} style={{ gap: 12 }}>
    {steps.map((label, index) => {
      const state = index === current ? 'active' : index < current ? 'done' : 'todo';
      return (
        <React.Fragment key={label}>
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            <Dot number={index + 1} state={state} />
            <Typography
              variant="body2"
              style={{ fontWeight: state === 'active' ? 700 : 400, color: state === 'active' ? '#6A2CC0' : '#555' }}
            >
              {label}
            </Typography>
          </Box>
          {index < steps.length - 1 && <div style={{ flex: 1, height: 1, background: '#D8D8E0' }} />}
        </React.Fragment>
      );
    })}
  </Box>
);
